"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var REACT_CONTEXT_TYPES = {
    portalClassName: function (obj, key) {
        if (obj[key] != null && typeof obj[key] !== 'string') {
            return new Error('Errors.PORTAL_CONTEXT_CLASS_NAME_STRING');
        }
        return undefined;
    }
};
// This component detaches its contents and re-attaches them to document.body.
// Use it when you need to circumvent DOM z-stacking (for dialogs, popovers, etc.).
// Any class names passed to this element will be propagated to the new container element on document.body.
var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    function Portal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Portal.prototype.render = function () {
        return null;
    };
    Portal.prototype.componentDidMount = function () {
        var targetElement = document.createElement('div');
        targetElement.classList.add('simple-portal');
        if (this.context.portalClassName != null) {
            targetElement.classList.add(this.context.portalClassName);
        }
        document.body.appendChild(targetElement);
        this.targetElement = targetElement;
        this.componentDidUpdate();
    };
    Portal.prototype.componentDidUpdate = function () {
        // use special render function to preserve React context, in case children need it
        var _this = this;
        ReactDOM.unstable_renderSubtreeIntoContainer(
        /* parentComponent */ this, React.createElement("div", __assign({}, this.props, { ref: this.props.containerRef }), this.props.children), this.targetElement, function () { return (_this.props.onChildrenMount ? _this.props.onChildrenMount() : null); });
    };
    Portal.prototype.componentWillUnmount = function () {
        ReactDOM.unmountComponentAtNode(this.targetElement);
        this.targetElement.remove();
    };
    Portal.displayName = 'Portal';
    Portal.contextTypes = REACT_CONTEXT_TYPES;
    return Portal;
}(React.Component));
exports.default = Portal;
//# sourceMappingURL=Portal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Portal/Portal.js
// module id = 263
// module chunks = 0